import {useGetWorkflowDefinitionListQuery} from 'src/redux/queries/workflowDefinition';
import {useGetSelectedField} from '../../../../../hooks/useFormBuilder';

export const useConnectedWorkflows = () => {
  const field = useGetSelectedField();

  const {
    data: workflowPayload,
    isFetching: isWorkflowFetching,
    isLoading: isWorkflowLoading,
  } = useGetWorkflowDefinitionListQuery({
    start: 0,
    length: 10000,
    formFieldInvariantId: field?.invariantId,
  });

  const isWorkflowsLoading = isWorkflowFetching || isWorkflowLoading;
  const connectedWorkflows = workflowPayload?.data ?? [];

  const hasConnectedWorkflows =
    !isWorkflowsLoading && connectedWorkflows.length > 0;

  return {
    connectedWorkflows,
    isWorkflowsLoading,
    hasConnectedWorkflows,
  };
};
